/* eslint-disable @typescript-eslint/no-explicit-any*/
import {
  TRANSFER_TRANSACTIONS,
  APPEND_TRANSACTIONS,
  TRANSACTION_GET_BILLET,
  SET_PIX_REVERSAL_REASONS,
  GET_SCHEDULED_TRANSACTIONS,
  CLEAR_TRANSACTIONS,
  SEND_TOTP_FOR_USER,
  SET_SUCCESS_PIN_FOR_TOTP,
  SET_DOWNLOAD_RECEIPT_LIST,
} from '~/actions/actionTypes';

const initialState: reducers.TransactionReducer = {
  transactions: [],
  scheduledTransactions: [],
  transactionsCancelToken: null,
  billetDetails: {
    transaction: null,
    pdf: null,
  },
  qrCode: {
    id: null,
    value: null,
  },
  isLast: false,
  pixReversalReason: [],
  sendSmsForTransaction: false,
  successTransferWithTotp: false,
  downloadReceiptURL: '',
};

const transactionReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case TRANSFER_TRANSACTIONS:
      state = {
        ...state,
        transactions: action.payload.rows,
        scheduledTransactions: action.payload.scheduledTransactions,
        isLast: action.payload.isLast,
      };
      break;

    case APPEND_TRANSACTIONS:
      state = {
        ...state,
        transactions: [...state.transactions, ...action.payload.rows],
        scheduledTransactions:
          action.payload.scheduledTransactions || state.scheduledTransactions,
        isLast: action.payload.isLast,
      };
      break;

    case CLEAR_TRANSACTIONS:
      state = {
        ...state,
        transactions: [],
        scheduledTransactions: [],
        isLast: false,
      };
      break;

    case TRANSACTION_GET_BILLET:
      state = {
        ...state,
        billetDetails: action.payload.billetInfo,
      };
      break;

    case GET_SCHEDULED_TRANSACTIONS:
      state = {
        ...state,
        scheduledTransactions: action.payload.rows,
      };
      break;

    case SET_PIX_REVERSAL_REASONS:
      state = {
        ...state,
        pixReversalReason: action.payload,
      };
      break;

    case SEND_TOTP_FOR_USER:
      state = {
        ...state,
        sendSmsForTransaction: action.payload,
      };
      break;
    case SET_SUCCESS_PIN_FOR_TOTP:
      state = {
        ...state,
        successTransferWithTotp: action.payload,
      };
      break;
    case SET_DOWNLOAD_RECEIPT_LIST:
      state = {
        ...state,
        downloadReceiptURL: action.payload.url,
      };
      break;

    default:
      return state;
  }

  return state;
};

export default transactionReducer;
